import { Checkbox, Tooltip } from '@material-ui/core';
import type { Activity } from '../../api/types';
import type { PortfolioSelection } from './usePortfolioSelection';

type SelectionProps = { selection: PortfolioSelection; busy: boolean };

export function PortfolioSelectionHeader({ selection, busy }: SelectionProps) {
  const { allEligibleSelected, selectedEligibleCount, eligibleActivityIds } =
    selection;
  const mixed = selectedEligibleCount > 0 && !allEligibleSelected;
  return (
    <Checkbox
      size="small"
      checked={allEligibleSelected}
      indeterminate={mixed}
      disabled={eligibleActivityIds.length === 0 || busy}
      inputProps={{
        'aria-label': 'Selecionar atividades elegíveis desta página',
        'aria-checked': mixed ? 'mixed' : allEligibleSelected,
      }}
      onClick={event => event.stopPropagation()}
      onChange={event => selection.selectAll(event.target.checked)}
    />
  );
}

export function PortfolioSelectionCell({
  activity,
  selection,
  busy,
}: SelectionProps & { activity: Activity }) {
  const protectedRow = activity.status === 'completed';
  const checkbox = (
    <Checkbox
      size="small"
      checked={selection.selectedIds.includes(activity.id)}
      disabled={protectedRow || busy}
      inputProps={{
        'aria-label': protectedRow
          ? `${activity.title}: atividade concluída, protegida contra exclusão`
          : `Selecionar ${activity.title} para exclusão`,
      }}
      onClick={event => event.stopPropagation()}
      onChange={event => selection.select(activity.id, event.target.checked)}
    />
  );
  return protectedRow ? (
    <Tooltip
      title="Atividades concluídas são permanentemente protegidas contra exclusão."
      arrow
    >
      <span>{checkbox}</span>
    </Tooltip>
  ) : (
    checkbox
  );
}
